import { NETWORK_NAMES } from '@features/lockup/constants';
import { lockupActions } from '@features/lockup/state/actions';
import { NetworkName } from '@features/lockup/types';
import { WEB3_CHAIN_DATA, WEB3_CHAIN_IDS } from '@features/web3/constants';
import { useWeb3 } from '@features/web3/hooks/use-web3';
import { CurrencyId, Web3ChainId, Web3ConnectStatus } from '@features/web3/types';
import { Web3Status } from '@features/web3/ui/web3-status';
import { getChainIdsByService } from '@features/web3/utils/get-chain-ids-by-service';
import { getServiceIdByPathname } from '@features/web3/utils/get-service-id-by-pathname';
import { toChainId } from '@features/web3/utils/to-chain-id';
import { toNetworkName } from '@features/web3/utils/to-network-name';
import LockDropDown from '@layout/lockup-dropdown';
import DropDownItem from '@layout/lockup-dropdown/item';
import NavPopupProducts from '@layout/nav-popup-products';
import { AppState } from '@state';
import { useOnClickOutside } from '@uikit/hooks/use-on-click-outside';
import classNames from 'classnames';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import scrollIntoView from 'scroll-into-view-if-needed';
import styles from './styles.module.scss';

const NavHomeTop = ({ style }: any) => {
  const { pathname } = useRouter();
  const { chainId, connectStatus } = useWeb3();
  const [state, setState] = useState({ isSticky: false, isOpened: false });
  const ref = useRef(null);
  const lockupNetworkName = useSelector<AppState, NetworkName>(state => state.lockup.networkName);
  const lockupChainId = toChainId(lockupNetworkName);
  const serviceId = getServiceIdByPathname(pathname);
  const allowedChainIds = getChainIdsByService(serviceId);
  const allowedCurrencyIds = allowedChainIds.map(chainId => WEB3_CHAIN_DATA[chainId].currencyId);
  const isWalletConnectOpened = useSelector<AppState, boolean>(state => state.modal.isWalletConnectOpened);
  const isUnknownConnectingStatus = connectStatus === Web3ConnectStatus.Unknown;
  const isAutoConnectingMetaMask = connectStatus === Web3ConnectStatus.Connecting && !isWalletConnectOpened;

  const isAllCurrenciesSupported =
    allowedCurrencyIds.includes(CurrencyId.Ethereum) && allowedCurrencyIds.includes(CurrencyId.Binance);

  const dispatch = useDispatch();
  const router = useRouter();

  /**
   *
   */
  useOnClickOutside(ref, () => setState({ ...state, isOpened: false }));

  /**
   *
   */
  useEffect(() => {
    window.addEventListener('resize', checkMob);
    if (window.pageYOffset > 10) {
      setState({ ...state, isSticky: true });
    } else {
      setState({ ...state, isSticky: false });
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMob);
    };
  }, []);

  /**
   *
   */
  function checkMob() {
    if (window.innerWidth > 1013 && state.isOpened) {
      setState({ ...state, isOpened: true });
    } else {
      if (window.pageYOffset > 10) {
        setState({ ...state, isOpened: false, isSticky: true });
      } else {
        setState({ ...state, isOpened: false });
      }
    }
  }

  /**
   *
   */
  function handleScroll() {
    if (window.innerWidth > 1013) {
      if (typeof window !== 'undefined' && window.pageYOffset > 10) {
        setState({ ...state, isSticky: true });
      } else {
        setState({ ...state, isSticky: false });
      }
    }
  }

  /**
   *
   * @param queryBlock
   * @param href
   */
  function scroll(queryBlock?: string | null, href?: string | null) {
    setState({ ...state, isOpened: false });

    if (queryBlock) {
      const feedback: any = document.getElementById(queryBlock);
      const popup: any = document.getElementById('popupProducts');

      if (feedback) {
        scrollIntoView(feedback, { block: 'start', behavior: 'smooth' });
        popup.setAttribute('style', 'display:none;');

        setTimeout(() => {
          popup.setAttribute('style', 'display:grid;');
        }, 100);
      } else {
        router.push(`/#${queryBlock}`);
      }
    } else if (href) {
      window.open(href, '_blank');
    }
  }

  /**
   *
   */
  function handleClick() {
    setState({ ...state, isOpened: !isOpened });
  }

  /**
   *
   * @param chainId
   */
  function handleSelectChainId(chainId: Web3ChainId) {
    const networkName = toNetworkName(chainId);
    const availableNetworkNames = Object.keys(NETWORK_NAMES) as NetworkName[];

    if (availableNetworkNames.includes(networkName as NetworkName)) {
      dispatch(lockupActions.setNetwork({ networkName: networkName as NetworkName }));
    }
  }

  const isWhite = state.isSticky;
  const isSticky = state.isSticky;
  const isOpened = state.isOpened;

  return (
    <div>
      <header
        className={classNames(
          styles.navHomeTop,
          'flex-row flex-center',
          isSticky && styles.navHomeTopSticky,
          isWhite && styles.navHomeTopWhite,
          isOpened && styles.navHomeTopOpened
        )}
        style={style}>
        {!isSticky && <div className={styles.borderLine} />}
        <nav className={classNames(styles.navHomeTopContent, 'container flex-row flex-space-between')} ref={ref}>
          <div className="flex-row flex-start">
            <Link href="/" className={styles.navHomeTopLogo}></Link>
          </div>

          <div className={classNames(styles.burger, 'flex-row flex-start hidden-desktop')} onClick={handleClick}>
            <div className={isOpened ? styles.burgerClose : styles.burgerOpen} />
          </div>

          <div className={classNames(styles.navHomeTopMenu, 'flex-center flex-column hidden-mobile')}>
            <div className={styles.navHomeTopMenuMobile}>
              <div className={styles.navHomeTopMenuMobileMenu}>
                <div className={styles.navHomeTopMenuMobileMenuItem}>
                  <h3>The Abyss</h3>

                  <div className={styles.menuMobile}>
                    <div className={styles.menuMobileBlock} onClick={() => scroll('Abyss', null)}>
                      <img src="/img/cards/abyss.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>Gaming platform</p>
                      </div>
                    </div>

                    <div className={styles.menuMobileBlock} onClick={() => scroll('Abyss', null)}>
                      <img src="/img/cards/market.svg" alt="" />
                      <div className={styles.menuMobileBlockText}>
                        <p>Marketplace</p>
                        <span style={{ color: '#4782f7' }}>NFT</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.navHomeTopMenuMobileMenuItem}>
                  <h3>Ethereum</h3>

                  <div className={styles.menuMobile}>
                    <div className={styles.menuMobileBlock} onClick={() => scroll('Ethereum', null)}>
                      <img src="/img/cards/eth.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>Free Hosting Service</p>
                        <span style={{ color: '#00bac2' }}>DeFi</span>
                      </div>
                    </div>

                    <div className={styles.menuMobileBlock} onClick={() => scroll('Ethereum', null)}>
                      <img src="/img/cards/depositor.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>Ethereum Depositor</p>
                        <span style={{ color: '#00bac2' }}>DeFi</span>
                      </div>
                    </div>

                    <div
                      className={styles.menuMobileBlock}
                      style={{ marginTop: 20 }}
                      onClick={() => scroll('Lockup', null)}>
                      <img src="/img/cards/lockup.svg" alt="" />

                      <div className={styles.menuMobileBlockText} style={{ marginTop: '-10px' }}>
                        <p>Lockup</p>
                        <div className={styles.popupProductsSnipets}>
                          <span style={{ color: '#00bac2' }}>DeFi</span>
                          <span style={{ color: 'rgb(138, 101, 247)' }}>ETHEREUM</span>
                          <span style={{ color: 'rgb(222, 176, 49)' }}>BSC</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.navHomeTopMenuMobileMenuItem}>
                  <h3>Abyss Masternodes</h3>

                  <div className={styles.menuMobile}>
                    <div className={styles.menuMobileBlock} onClick={() => scroll('Masternodes', null)}>
                      <img src="/img/cards/lightnodes.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>Lunar nodes</p>
                      </div>
                    </div>

                    <div className={styles.menuMobileBlock} onClick={() => scroll('Masternodes', null)}>
                      <img src="/img/cards/darknodes-copy.svg" alt="" />
                      <div className={styles.menuMobileBlockText}>
                        <p>Solar nodes</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.navHomeTopMenuMobileMenuItem}>
                  <h3>ABYSS STAKING</h3>

                  <div className={styles.menuMobile}>
                    <div className={styles.menuMobileBlock} onClick={() => scroll('Staking', null)}>
                      <img src="/img/cards/pure.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>Guilds</p>
                        <span style={{ color: '#00bac2' }}>DeFi</span>
                      </div>
                    </div>

                    <div className={styles.menuMobileBlock} onClick={() => scroll('Staking', null)}>
                      <img src="/img/cards/syndicates.svg" alt="" />
                      <div className={styles.menuMobileBlockText}>
                        <p>Syndicates</p>
                        <span style={{ color: '#00bac2' }}>DeFi</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.navHomeTopMenuMobileMenuItem}>
                  <h3>Crowdfunding</h3>

                  <div className={styles.menuMobile}>
                    <div className={styles.menuMobileBlock} onClick={() => scroll('Crowdfunding', null)}>
                      <img src="/img/cards/daico.svg" alt="" />

                      <div className={styles.menuMobileBlockText}>
                        <p>DAICO</p>
                        <span style={{ color: '#00bac2' }}>DeFi</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.navHomeTopMenuMobileSocial}>
                <div className={styles.navIconSocial}>
                  <a href="https://medium.com/abyssfinance" target="_blank" rel="noreferrer noopener">
                    <img src="/img/cards/medium.svg" alt="" />
                  </a>

                  <a href="https://www.reddit.com/r/AbyssFinance/" target="_blank" rel="noreferrer noopener">
                    <img src="/img/cards/reddit.svg" alt="" style={{ marginTop: '-4px' }} />
                  </a>

                  <a href="https://www.facebook.com/AbyssFinance" target="_blank" rel="noreferrer noopener">
                    <img src="/img/cards/facebook.svg" alt="" style={{ marginTop: '-3px' }} />
                  </a>

                  <a href="https://t.me/abyssfinance" target="_blank" rel="noreferrer noopener">
                    <img src="/img/cards/telegram.svg" alt="" />
                  </a>

                  <a href="https://twitter.com/AbyssFinance" target="_blank" rel="noreferrer noopener">
                    <img src="/img/cards/twitter.svg" alt="" />
                  </a>
                </div>

                <Link href="/docs" className="disabled-menu">
                  Docs
                </Link>

                <a href="https://github.com/abyssfinance" target="_blank" rel="noreferrer noopener">
                  GitHub
                </a>

                <p>&copy; {moment.utc().format('YYYY')} Abyss Finance</p>
              </div>
            </div>

            <ul className={classNames(styles.navHomeTopLinks, 'flex-row flex-center')}>
              {isUnknownConnectingStatus || isAutoConnectingMetaMask ? null : (
                <div className={styles.smartChain}>
                  {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Ethereum) ||
                  (chainId == null && allowedCurrencyIds.includes(CurrencyId.Ethereum)) ? (
                    <div
                      className={classNames(styles.button, {
                        [styles.buttonActive]:
                          chainId === null &&
                          isAllCurrenciesSupported &&
                          WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Ethereum
                      })}
                      style={{
                        cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                      }}
                      onClick={() => {
                        if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Ethereum) {
                          dispatch(lockupActions.setNetwork({ networkName: 'mainnet' }));
                        }
                      }}>
                      Ethereum
                    </div>
                  ) : null}

                  {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Binance) ||
                  (chainId == null && allowedCurrencyIds.includes(CurrencyId.Binance)) ? (
                    <div
                      className={classNames(styles.button, {
                        [styles.buttonActive]:
                          chainId === null &&
                          isAllCurrenciesSupported &&
                          WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Binance
                      })}
                      style={{
                        cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                      }}
                      onClick={() => {
                        if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Binance) {
                          dispatch(lockupActions.setNetwork({ networkName: 'bscMainnet' }));
                        }
                      }}>
                      Binance Smart Chain
                    </div>
                  ) : null}

                  {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Pulsechain) ||
                  (chainId == null && allowedCurrencyIds.includes(CurrencyId.Pulsechain)) ? (
                    <div
                      className={classNames(styles.button, {
                        [styles.buttonActive]:
                          chainId === null &&
                          isAllCurrenciesSupported &&
                          WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Pulsechain
                      })}
                      style={{
                        cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                      }}
                      onClick={() => {
                        if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Pulsechain) {
                          dispatch(lockupActions.setNetwork({ networkName: 'pulsechainMainnet' }));
                        }
                      }}>
                      PulseChain
                    </div>
                  ) : null}
                </div>
              )}

              {[Web3ConnectStatus.Unknown, Web3ConnectStatus.Connecting].includes(connectStatus) ? null : chainId ==
                null ? (
                <LockDropDown
                  value={WEB3_CHAIN_DATA[lockupChainId].title}
                  type={WEB3_CHAIN_DATA[lockupChainId].colorScheme}>
                  {WEB3_CHAIN_IDS.filter(chainId => {
                    const lockupCurrencyId = WEB3_CHAIN_DATA[lockupChainId].currencyId;
                    const currencyId = WEB3_CHAIN_DATA[chainId].currencyId;

                    return (
                      allowedChainIds.includes(chainId) && lockupCurrencyId === currencyId && lockupChainId !== chainId
                    );
                  }).map(chainId => (
                    <DropDownItem
                      key={chainId}
                      text={WEB3_CHAIN_DATA[chainId].title}
                      onClick={() => handleSelectChainId(chainId)}
                    />
                  ))}
                </LockDropDown>
              ) : chainId && WEB3_CHAIN_DATA[chainId] ? (
                <LockDropDown
                  disabled={true}
                  value={WEB3_CHAIN_DATA[chainId].title}
                  type={WEB3_CHAIN_DATA[chainId].colorScheme}>
                  {null}
                </LockDropDown>
              ) : null}
              <Web3Status />
            </ul>
          </div>
        </nav>
      </header>

      <div className={styles.chainMenuMobile}>
        <ul className={classNames(styles.navHomeTopLinks, 'flex-row flex-center')}>
          {isUnknownConnectingStatus || isAutoConnectingMetaMask ? null : (
            <div className={classNames(styles.smartChain, styles.isMobile)}>
              {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Ethereum) ||
              (chainId == null && allowedCurrencyIds.includes(CurrencyId.Ethereum)) ? (
                <div
                  className={classNames(styles.button, {
                    [styles.buttonActive]:
                      chainId === null &&
                      isAllCurrenciesSupported &&
                      WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Ethereum
                  })}
                  style={{
                    cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Ethereum) {
                      dispatch(lockupActions.setNetwork({ networkName: 'mainnet' }));
                    }
                  }}>
                  ETH
                </div>
              ) : null}

              {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Binance) ||
              (chainId == null && allowedCurrencyIds.includes(CurrencyId.Binance)) ? (
                <div
                  className={classNames(styles.button, {
                    [styles.buttonActive]:
                      chainId === null &&
                      isAllCurrenciesSupported &&
                      WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Binance
                  })}
                  style={{
                    cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Binance) {
                      dispatch(lockupActions.setNetwork({ networkName: 'bscMainnet' }));
                    }
                  }}>
                  BNB
                </div>
              ) : null}

              {(chainId && WEB3_CHAIN_DATA[chainId].currencyId === CurrencyId.Pulsechain) ||
              (chainId == null && allowedCurrencyIds.includes(CurrencyId.Pulsechain)) ? (
                <div
                  className={classNames(styles.button, {
                    [styles.buttonActive]:
                      chainId === null &&
                      isAllCurrenciesSupported &&
                      WEB3_CHAIN_DATA[lockupChainId].currencyId === CurrencyId.Pulsechain
                  })}
                  style={{
                    cursor: chainId === null && isAllCurrenciesSupported ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (chainId === null && WEB3_CHAIN_DATA[lockupChainId].currencyId !== CurrencyId.Pulsechain) {
                      dispatch(lockupActions.setNetwork({ networkName: 'pulsechainMainnet' }));
                    }
                  }}>
                  PLS
                </div>
              ) : null}
            </div>
          )}

          {[Web3ConnectStatus.Unknown, Web3ConnectStatus.Connecting].includes(connectStatus) ? null : chainId ==
            null ? (
            <LockDropDown
              value={WEB3_CHAIN_DATA[lockupChainId].title}
              type={WEB3_CHAIN_DATA[lockupChainId].colorScheme}>
              {WEB3_CHAIN_IDS.filter(chainId => {
                const lockupCurrencyId = WEB3_CHAIN_DATA[lockupChainId].currencyId;
                const currencyId = WEB3_CHAIN_DATA[chainId].currencyId;

                return (
                  allowedChainIds.includes(chainId) && lockupCurrencyId === currencyId && lockupChainId !== chainId
                );
              }).map(chainId => (
                <DropDownItem
                  key={chainId}
                  text={WEB3_CHAIN_DATA[chainId].title}
                  onClick={() => handleSelectChainId(chainId)}
                />
              ))}
            </LockDropDown>
          ) : chainId && WEB3_CHAIN_DATA[chainId] ? (
            <LockDropDown
              disabled={true}
              value={WEB3_CHAIN_DATA[chainId].title}
              type={WEB3_CHAIN_DATA[chainId].colorScheme}>
              {null}
            </LockDropDown>
          ) : null}
          <Web3Status />
        </ul>
      </div>

      <div className={styles.subMenu}>
        <div className="container">
          <ul>
            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-mobile')}>
              Products
              <NavPopupProducts />
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-desktop')}>
              <Link href="/lightnodes">Lightnodes</Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-desktop')}>
              <Link href="/darknodes">Darknodes</Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-desktop')}>
              <Link href="/guild">Guild</Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-desktop')}>
              <Link href="/syndicate">Syndicate</Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-desktop')}>
              <Link href="/daico">Daico</Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'disabled-menu hidden-mobile')}>
              <Link href="/docs" className="disabled-menu">
                Docs
              </Link>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, 'hidden-mobile')}>
              <a href="https://github.com/abyssfinance" target="_blank" rel="noreferrer noopener">
                GitHub
              </a>
            </li>

            {/* medium */}
            <li className={classNames(styles.navHomeTopLinkWrapper, styles.navIconLink, 'hidden-mobile')}>
              <a href="https://medium.com/abyssfinance" target="_blank" rel="noreferrer noopener">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16">
                  <g fill="none" fillRule="evenodd">
                    <g fill="#202020" fillRule="nonzero">
                      <path
                        d="M1322.794 129c0 4.418-3.536 8-7.897 8-4.362 0-7.897-3.58-7.897-8s3.536-8 7.897-8c4.36 0 7.897 3.582 7.897 8m8.663 0c0 4.16-1.768 7.53-3.949 7.53-2.18 0-3.948-3.372-3.948-7.53s1.768-7.53 3.948-7.53c2.18 0 3.949 3.372 3.949 7.53m3.543 0c0 3.726-.622 6.747-1.389 6.747s-1.388-3.022-1.388-6.747c0-3.726.621-6.747 1.389-6.747.767 0 1.388 3.02 1.388 6.747"
                        transform="translate(-1307 -121)"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            </li>

            {/* reddit */}
            <li className={classNames(styles.navHomeTopLinkWrapper, styles.navIconLink, 'hidden-mobile')}>
              <a href="https://www.reddit.com/r/AbyssFinance/" target="_blank" rel="noreferrer noopener">
                <svg width="24px" height="22px" viewBox="0 0 24 22" version="1.1">
                  <title>reddit</title>
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                      id="AF-Desktop"
                      transform="translate(-1365.000000, -117.000000)"
                      fill="#202020"
                      fillRule="nonzero">
                      <g id="reddit" transform="translate(1365.000000, 117.000000)">
                        <path
                          d="M20,0 C21.1045695,0 22,0.8954305 22,2 C22,3.1045695 21.1045695,4 20,4 C19.3111987,4 18.7037247,3.65179599 18.3440004,3.12181024 C17.6203082,3.23420745 16.9100102,3.4202959 16.2489344,3.6927028 C14.993659,4.20995925 14.0359171,4.9817196 13.4393925,6.06739725 C16.0025325,6.3091998 18.3040696,7.1886542 20.0063911,8.4950323 C20.423121,8.1840832 20.940063,8 21.5,8 C22.8807119,8 24,9.11928815 24,10.5 C24,11.3882418 23.5367685,12.16829 22.838709,12.611741 C22.9446955,13.061251 23,13.5249657 23,14 C23,18.5102007 18.0145724,22 12,22 C5.9854276,22 1,18.5102007 1,14 C1,13.5249657 1.05530451,13.061251 1.16129106,12.611741 C0.463231567,12.16829 0,11.3882418 0,10.5 C0,9.11928815 1.11928812,8 2.5,8 C3.059937,8 3.57687907,8.1840832 3.99360896,8.4950323 C5.8507417,7.0698505 8.42103265,6.1527732 11.2661298,6.017407 C12.0160537,4.0253667 13.506838,2.65948336 15.4869583,1.84354289 C16.3576644,1.48475445 17.2760931,1.25229926 18.2031018,1.12081869 C18.5284949,0.457021215 19.2108759,0 20,0 Z M9.24687218,16.1364347 C8.88040422,15.889625 8.38324444,15.9866272 8.13643474,16.3530952 C7.88962504,16.7195632 7.98662722,17.2167229 8.35309521,17.4635326 C8.55333299,17.5983893 8.89651087,17.7788913 9.37249622,17.9529845 C10.143766,18.235079 11.0241921,18.4033366 12,18.4033366 C12.975808,18.4033366 13.8562341,18.235079 14.6275039,17.9529845 C15.1034892,17.7788913 15.4466671,17.5983893 15.6469049,17.4635326 C16.0133729,17.2167229 16.110375,16.7195632 15.8635653,16.3530952 C15.6167556,15.9866272 15.1195958,15.889625 14.7531279,16.1364347 C14.7392577,16.145776 14.2837809,16.3750314 14.0779035,16.4503317 C13.4764093,16.6703302 12.7804815,16.8033284 12,16.8033284 C11.2195185,16.8033284 10.5235907,16.6703302 9.92209654,16.4503317 C9.71621917,16.3750314 9.26074233,16.145776 9.24687218,16.1364347 Z M8,11 C7.1715729,11 6.5,11.6715729 6.5,12.5 C6.5,13.3284271 7.1715729,14 8,14 C8.8284271,14 9.5,13.3284271 9.5,12.5 C9.5,11.6715729 8.8284271,11 8,11 Z M16,11 C15.1715729,11 14.5,11.6715729 14.5,12.5 C14.5,13.3284271 15.1715729,14 16,14 C16.8284271,14 17.5,13.3284271 17.5,12.5 C17.5,11.6715729 16.8284271,11 16,11 Z"
                          id="Combined-Shape"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>

            {/* facebook */}
            <li className={classNames(styles.navHomeTopLinkWrapper, styles.navIconLink, 'hidden-mobile')}>
              <a href="https://www.facebook.com/AbyssFinance" target="_blank" rel="noreferrer noopener">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                  <g fill="none" fillRule="evenodd">
                    <g fill="#202020" fillRule="nonzero">
                      <g>
                        <path
                          d="M11 0C4.925 0 0 4.925 0 11c0 5.515 4.063 10.069 9.356 10.864v-7.949H6.635v-2.891h2.721V9.1c0-3.185 1.552-4.584 4.2-4.584 1.268 0 1.938.094 2.256.137v2.524h-1.806c-1.124 0-1.517 1.066-1.517 2.267v1.58h3.294l-.447 2.892h-2.847v7.971C17.858 21.16 22 16.569 22 11c0-6.075-4.925-11-11-11z"
                          transform="translate(-1419 -117) translate(1419 117)"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, styles.navIconLink, 'hidden-mobile')}>
              <a href="https://t.me/abyssfinance" target="_blank" rel="noreferrer noopener">
                <svg width="22px" height="18px" viewBox="0 0 22 18" version="1.1">
                  <title>telegram</title>
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="AF-Mobile" transform="translate(-21.000000, -3311.000000)" fill="#222222" fillRule="nonzero">
                      <g id="Group" transform="translate(20.000000, 3254.000000)">
                        <path
                          d="M2.4823562,64.7377146 C9.25226081,61.8105995 18.0124593,58.2418989 19.2221318,57.747859 C22.3940113,56.4551689 23.3673666,56.7026648 22.8821417,59.566002 C22.5334771,61.6240257 21.5281608,68.4368264 20.7262322,72.6775736 C20.2506924,75.1925128 19.1833913,75.4904598 17.5059271,74.4024297 C16.6991559,73.8788807 12.6265595,71.2316264 11.7423073,70.6100309 C10.9355361,70.043646 9.82271486,69.3620804 11.2183418,68.019891 C11.7151889,67.5420336 14.9703605,64.486411 17.5068956,62.1085465 C17.8390955,61.7963209 17.4216664,61.2832429 17.0381354,61.5335945 C13.6192851,63.7620095 8.87938337,66.8547565 8.27599989,67.2574133 C7.36462933,67.865682 6.48909374,68.1445909 4.91816594,67.7010021 C3.73076923,67.3659307 2.57145938,66.9661296 2.12013241,66.8138244 C0.381651899,66.2274495 0.79423836,65.4678275 2.4823562,64.7377146 Z"
                          id="telegram"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>

            <li className={classNames(styles.navHomeTopLinkWrapper, styles.navIconLink, 'hidden-mobile')}>
              <a href="https://twitter.com/AbyssFinance" target="_blank" rel="noreferrer noopener">
                <svg width="22px" height="18px" viewBox="0 0 22 18" version="1.1">
                  <title>twitter</title>
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="AF-Mobile" transform="translate(-75.000000, -3311.000000)" fill="#222222" fillRule="nonzero">
                      <g id="Group" transform="translate(20.000000, 3254.000000)">
                        <path
                          d="M77,59.1306262 C76.1902619,59.4926878 75.3204492,59.7363339 74.4074843,59.8462303 C75.33991,59.2839699 76.0548825,58.3937243 76.3916388,57.3322448 C75.5201338,57.8527616 74.5538633,58.2310095 73.5249798,58.4354678 C72.7017038,57.5520375 71.5289797,57 70.2310296,57 C67.7383562,57 65.7178185,59.0352123 65.7178185,61.5440863 C65.7178185,61.9001846 65.7584324,62.2477637 65.8345833,62.5791566 C62.0837275,62.3900327 58.7584708,60.5805765 56.5314796,57.830612 C56.143956,58.5019168 55.9214261,59.2822661 55.9214261,60.1162857 C55.9214261,61.6923186 56.7176262,63.0834872 57.9284258,63.8979128 C57.1889158,63.8740593 56.492558,63.669601 55.8841968,63.3296891 C55.8841968,63.349283 55.8841968,63.3671731 55.8841968,63.386767 C55.8841968,65.5889536 57.4393677,67.4256709 59.5047498,67.8422547 C59.1265336,67.9461877 58.7271643,68.0015618 58.3151033,68.0015618 C58.0248837,68.0015618 57.741433,67.9725969 57.4664436,67.9206304 C58.04096,69.7258271 59.7078189,71.0403237 61.6826661,71.0769558 C60.1384947,72.2960386 58.1924157,73.0227176 56.0771124,73.0227176 C55.7132803,73.0227176 55.3536787,73.0014198 55,72.9588244 C56.9976924,74.2477637 59.3693704,75 61.9187339,75 C70.2208761,75 74.7594708,68.075678 74.7594708,62.0705665 C74.7594708,61.8737754 74.7552402,61.6778361 74.746779,61.4827488 C75.6292835,60.8412608 76.3950233,60.0413176 77,59.1306262 Z"
                          id="twitter"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavHomeTop;
